import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ResultColumnsService {

  cols: any[];
  fixedcolumns: any[];

  private selectedColsSubject = new BehaviorSubject<any[]>([]);
  public selectedCols$ = this.selectedColsSubject.asObservable();

  constructor() {
    this.cols = [
      // { field: 'AccessionNumber', header: 'Accession Number', sortField: "document.AccessionNumber" },
      { field: 'Availability', header: 'Availability', sortField: "document.Availability" },
      { field: 'DocumentTitle', header: 'Document Title', sortField: "document.DocumentTitle" },
      { field: 'DocumentType', header: 'Doc Type', sortField: "document.DocumentType" },
      { field: 'DocumentDate', header: 'Doc Date', sortField: "document.DocumentDate" },
      { field: 'AuthorName', header: 'Author(s)', sortField: "document.AuthorName" },// AuthorName: string[];
      { field: 'AuthorAffiliation', header: 'Author Affiliation', sortField: "document.AuthorAffiliation" },// AuthorAffiliation: string[];
      { field: 'AddresseeName', header: 'Addressee Name', sortField: "document.AddresseeName" },// AddresseeName: string[];
      { field: 'AddresseeAffiliation', header: 'Addressee Affiliation', sortField: "document.AddresseeAffiliation" },// AddresseeAffiliation: string[];
      { field: 'CaseReferenceNumber', header: 'Case Ref. #', sortField: "document.CaseReferenceNumber" },// CaseReferenceNumber: string[];
      { field: 'Comment', header: 'Comment', sortField: "document.Comment" },
      { field: 'ContactPerson', header: 'Contact', sortField: "document.ContactPerson" },// ContactPerson?: string;
      // { field: 'DateAdded', header: 'Date Added', sortField: "document.DateAdded" },// DateAdded?: string;
      { field: 'DocumentReportNumber', header: 'Doc. Rep. #', sortField: "document.DocumentReportNumber" },// DocumentReportNumber: string[];
      { field: 'DocketNumber', header: 'Docket #', sortField: "document.DocketNumber" },// DocketNumber: string[];
      { field: 'DistributionListCodes', header: 'Dist. List Codes', sortField: "document.DistributionListCodes" },// DistributionListCodes?: string;
      { field: 'Keyword', header: 'Keyword', sortField: "document.Keyword" },
      { field: 'LicenseNumber', header: 'License #', sortField: "document.LicenseNumber" },// LicenseNumber: string[];
      { field: 'PackageNumber', header: 'Package #', sortField: "document.PackageNumber" },// PackageNumber?: string;
      { field: 'PackagesFiledIn', header: 'Packages Filed In', sortField: "document.PackagesFiledIn" },// PackageNumber?: string;
      { field: 'ASLBPNumber', header: 'ASLBP Number', sortField: "document.ASLBPNumber" },
      { field: 'CUIDocumentSensitivity', header: 'CUI Doc Sensitivity', sortField: "document.CUIDocumentSensitivity" },
      { field: 'DateToBeReleased', header: 'Date To Be Rel.', sortField: "document.DateToBeReleased" },
      { field: 'DocumentDateReceived', header: 'Doc Date Received', sortField: "document.DocumentDateReceived" },
      { field: 'DocumentStatus', header: 'Doc. Status', sortField: "document.DocumentStatus" },
      { field: 'FoldersFiledIn', header: 'Folders', sortField: "document.FoldersFiledIn" },
      { field: 'DocumentSensitivity', header: 'Doc. Sensitivity', sortField: "document.DocumentSensitivity" },
      { field: 'ExhibitStatus', header: 'Exhibit Status', sortField: "document.ExhibitStatus" },
      { field: 'FACADocument', header: 'FACA Document', sortField: "document.FACADocument" },
      { field: 'Replicated', header: 'Replicated', sortField: "document.Replicated" },
      { field: 'TextSourceFlag', header: 'Text Source Flag', sortField: "document.TextSourceFlag" },
      { field: 'VitalRecordsCategory', header: 'Vital Records Category', sortField: "document.VitalRecordsCategory" },
      { field: 'DateReviewedForPublicRelease', header: 'Date Rev For Pub Rel', sortField: "document.DateReviewedForPublicRelease" },
      { field: 'DateDocketed', header: 'Doc. Date Docketed', sortField: "document.DateDocketed" },
      { field: 'DateDeclared', header: 'Date Declared', sortField: "document.DateDeclared" },
      { field: 'RelatedDate', header: 'Related Date', sortField: "document.RelatedDate" },
      { field: 'PublishedtoEHDDate', header: 'Date Pub To EHD', sortField: "document.PublishedtoEHDDate" },
      { field: 'OfficialRecord', header: 'Official Record', sortField: "document.OfficialRecord" },
      { field: 'HearingOfficialExhibitNumber', header: 'Hearing Official Exhibit No.', sortField: "document.HearingOfficialExhibitNumber" },
      { field: 'HearingPartyExhibitNumber', header: 'Hearing Party Exhibit No.', sortField: "document.HearingPartyExhibitNumber" },
      { field: 'HearingPartyIdentifier', header: 'Hearing Party Id', sortField: "document.HearingPartyIdentifier" },
      { field: 'DateAddedTimestamp', header: 'Date Added', sortField: 'document.DateAddedTimestamp'},
      { field: 'ProceedingsFiledIn', header: 'Proceedings Filed In', sortField: "document.ProceedingsFiledIn" }
    ];

    this.fixedcolumns = [{ field: 'AccessionNumber', header: 'Accession Number', sortField: "document.AccessionNumber" },
    { field: 'DocumentTitle', header: 'Document Title', sortField: "document.DocumentTitle" },
    { field: 'DateAddedTimestamp', header: 'Date Added', sortField: 'document.DateAddedTimestamp'},
    { field: 'DocumentDate', header: 'Doc Date', sortField: "document.DocumentDate" }
    // { field: 'DateAdded', header: 'Date Added', sortField: "document.DateAdded" },
    ];
  }
  
  setSelectedCols(cols: any[]) {
    this.selectedColsSubject.next(cols);
  }

  getSelectedCols(): any[] {
    return this.selectedColsSubject.value;
  }

  parseSelectedCols(tableCols: any) {
    let selectedCols: any[] = [];
    let tc = tableCols;
    if (typeof (tc) == 'string') {
      tc = JSON.parse(tc);
    }

    tc.forEach((colItem: string) => {
      let sc = this.cols.find((c) => c["field"] == colItem);

      if (sc) {
        //Avoid adding duplicates...
        if (selectedCols.length > 0) {
          let exists = selectedCols.find((item) => item["field"] == sc["field"]);
          if (!exists) {
            selectedCols.push(sc);
          }
        }
        else {
          selectedCols.push(sc);
        }
      }
    });

    this.setSelectedCols(selectedCols);
  }
}
